export const notificar = (mensaje, ok) => {
  let mensajePantalla = mensaje;
  if (mensaje === "TypeError: Failed to fetch") {
    mensajePantalla = "Error al conectar con el servicio";
  }
  var notificacion = ok
    ? sucessNotification(mensajePantalla, null)
    : errorNotification(mensajePantalla, null);
  return notificacion;
};

export const notificacionObj = () => {
  return {
    error: false,
    success: false,
    open: false,
    color: "danger",
    helperText: "",
    errorGeneral: ""
  };
};

export const errorNotification = (mensaje, helperMsj) => {
  return {
    error: true,
    success: false,
    open: true,
    color: "danger",
    helperText: helperMsj,
    errorGeneral: mensaje
  };
};

export const sucessNotification = (mensaje, helperMsj) => {
  return {
    error: false,
    success: true,
    open: true,
    color: "success",
    helperText: helperMsj,
    errorGeneral: mensaje
  };
};
